import type { Menu } from '#/global'

const menu: Menu.recordRaw = {
  path: '/announcement/list',
  meta: { title: '系统公告', icon: 'i-ep:bell' },
}

export default menu
